// TODO: PRDENG-121
export const COLORS = {
  BLUE: '#6488E9',
  RED: '#FF524C',
  GREEN: '#2A9D90',
  BROWN: '#9D572A',
  DARK_BLUE: '#041A45',
  GRAY: '#60646C',
  LIGHT_GRAY: '#D9D9D9',
  MUSTARD: '#E9C564',
  VIOLET: '#8264E9',
  CYAN: '#4CF9FF',
  LIME: '#A0FF4C'
};
export const PROFILES_COLORS = {
  // Primary & Actions
  primary: '#00B4A6', // Vibrant Teal - main action color
  primaryLight: '#E6F9F7', // Light teal background
  primaryDark: '#008F84', // Darker teal for hover

  // Status Colors (Color-blind safe)
  statusActive: '#0066CC', // Rich Blue - universally visible
  statusActiveLight: '#E6F2FF',
  statusInactive: '#6B7280', // Neutral Gray
  statusInactiveLight: '#F3F4F6',

  // Stat Card Colors (Distinct for color-blind users)
  statBlue: '#0066CC', // Rich Blue
  statOrange: '#FF8C42', // Vibrant Orange
  statPurple: '#8B5CF6', // Deep Purple
  statTeal: '#D4FCB6', // Teal

  // Stat Light Backgrounds
  statBlueLight: '#E6F2FF',
  statOrangeLight: '#FFF4E6',
  statPurpleLight: '#F3EDFF',
  statTealLight: '#E6F9F7',

  // Avatar Colors (Color-blind friendly spectrum)
  avatarBlue: '#0066CC', // Rich Blue
  avatarOrange: '#FF8C42', // Vibrant Orange
  avatarPurple: '#8B5CF6', // Deep Purple
  avatarTeal: '#00B4A6', // Teal
  avatarIndigo: '#4F46E5', // Indigo
  avatarAmber: '#F59E0B', // Amber
  avatarCyan: '#06B6D4', // Cyan
  avatarViolet: '#7C3AED', // Violet

  // Border Colors
  borderPrimary: '#00B4A6',
  borderBlue: '#0066CC',
  borderOrange: '#FF8C42',
  borderPurple: '#8B5CF6',
  borderGray: '#9CA3AF',

  // Background
  backgroundGradientFrom: '#F8FAFC',
  backgroundGradientTo: '#EFF6FF'
};

// Cases Priority Colors
export const CASES_PRIORITY_COLORS = {
  low: {
    bg: 'bg-slate-50',
    text: 'text-slate-700',
    border: 'border-slate-300'
  },
  medium: {
    bg: 'bg-yellow-50',
    text: 'text-yellow-700',
    border: 'border-yellow-300'
  },
  high: {
    bg: 'bg-orange-50',
    text: 'text-orange-700',
    border: 'border-orange-300'
  },
  critical: {
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-300'
  },
  urgent: {
    bg: 'bg-[#9B1635]/5',
    text: 'text-[#9B1635]',
    border: 'border-[#9B1635]/30'
  }
};
